import axios from 'axios';
import {
  PROJECT_ON_BOARD_GET_XANO_SCHEMA_BEGIN,
  PROJECT_ON_BOARD_GET_XANO_SCHEMA_SUCCESS,
  PROJECT_ON_BOARD_GET_XANO_SCHEMA_FAILURE,
  PROJECT_ON_BOARD_GET_XANO_SCHEMA_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';

export function getXanoSchema(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_GET_XANO_SCHEMA_BEGIN,
    });
    const header = {
      headers: {
        Authorization: `Bearer ${args.developerKey}`,
        'Content-Type': 'application/json',
      },
    };
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get('https://x8ki-letl-twmt.n7.xano.io/api:meta/workspace', {
        headers: header.headers
      });
      console.log('object', doRequest);
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_GET_XANO_SCHEMA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_GET_XANO_SCHEMA_FAILURE,
            data: { error: err },
          });
          toast.error('invalid access token !');
          console.log('api calling error>>>>>', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetXanoSchemaError() {
  return {
    type: PROJECT_ON_BOARD_GET_XANO_SCHEMA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_GET_XANO_SCHEMA_BEGIN:
      return {
        ...state,
        getXanoSchemaPending: true,
        getXanoSchemaError: null,
      };

    case PROJECT_ON_BOARD_GET_XANO_SCHEMA_SUCCESS:
      return {
        ...state,
        getXanoSchemaPending: false,
        getXanoSchemaError: null,
        xanoData: action.data,
      };

    case PROJECT_ON_BOARD_GET_XANO_SCHEMA_FAILURE:
      return {
        ...state,
        getXanoSchemaPending: false,
        getXanoSchemaError: action.data.error,
      };

    case PROJECT_ON_BOARD_GET_XANO_SCHEMA_DISMISS_ERROR:
      return {
        ...state,
        getXanoSchemaError: null,
      };

    default:
      return state;
  }
}
